import React from 'react';
import { useConnect } from '@lore/query-connect';
import { tags_partner } from '../../../../utils/query-helpers';

export default function useOrganizations(network, schoolStart, schoolEnd, extra = {}, eager = {}) {
  return useConnect('organization.find', {
    where: {
      eager: {
        $aggregations: [
          {
            type: 'count',
            alias: 'numberOfPartners',
            relation: 'users',
            $where: {
              ...tags_partner(),
              // 'networks.id': network?.id
              networkId: network?.id
            }
          }
        ],
        $where: {
          createdAt: {
            $lte: schoolEnd,
            $gte: schoolStart
          },
          ...extra
        },
        $eager: eager,
        $having: {
          numberOfPartners: {
            $gt: 0
          }
        }
      },
    },
    pagination: {
      pageSize: 1
    }
  });
}
